module.exports = __webpack_public_path__ + "img/mobile-marketing-rafiki.5872341e.svg";